import type { ConnectionState } from "@agency/core";
import { useT } from "../i18n";
import { Badge } from "./ui";

/** Plain-language connection state, computed on the server. Demo = sample behavior; Live = real provider. */
export function StateBadge({ state, className }: { state?: ConnectionState | string | null; className?: string }) {
  const t = useT();
  const s = (state ?? "not_connected") as ConnectionState;
  const tone = s === "live" ? "green" : s === "test" ? "blue" : s === "demo" ? "amber" : s === "ready_for_setup" ? "ink" : "neutral";
  return (
    <Badge tone={tone} className={className}>
      <span className={`h-1.5 w-1.5 rounded-full ${s === "live" ? "bg-primary-dark" : s === "demo" ? "bg-amber-600" : "bg-current opacity-50"}`} />
      {t(`state.${s}`)}
    </Badge>
  );
}
